import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'

export default {
  namespaced: true,
  actions: {
    async createMessage(context, message) {
      const response = await http.post(`message/`, {
        content: message.content,
        level: 'INFO',
        whom: message.whom,
        userId: message.whom === 'INDIVIDUAL' ? message.userId : null,
      })

      return response
    },
    async updateMessage(context, message) {
      const response = await http.put(`message/${message.id}`, {
        content: message.content,
        level: 'INFO',
      })

      return response
    },
    async updateMessageStatus(context, { id, status }) {
      const response = await http.put(`message/${id}/status/?status=${status}`)

      return response
    },
    async searchMessages(context, params) {
      const response = await http.get(`message/${requestUrlFunction(params)}`)

      return response
    },
    async getMessage(context, id) {
      const response = await http.get(`message/${id}`)

      return response
    },
    async deleteMessage(context, id) {
      const response = await http.delete(`message/${id}`)

      return response
    },
    async searchMessageUsers(context, params) {
      const response = await http.get(`message/user/${requestUrlFunction(params)}`)

      return response
    },
  },
}
